import React from 'react'
import Chart from './Chart'
import Layout from '../../../layouts/Layout'
import { Header, Button, Grid, Icon } from 'semantic-ui-react'
import {
  countryData,
  nameToId
} from '../mapData'
import { browserHistory } from 'react-router'

const toolkitCountry = ({ params, getChart }) => {
  const typeList = ['Ethnic/Racial', 'Religious', 'Political', 'Gender/Sex/Orientation',
  'Socio-Economic']
    return (<Layout link={['Toolkit', params.id]}>
      <Header as='h1'>{typeList[params.type]} Polarisation and resilience compared across the EU</Header>
      <Header as='h2'>
        {typeList[params.type]} Polarisation score vs. Resilience score per Country
      </Header>
      <Chart data={countryData[params.type]} width={950} height={350} country={params.id} />
      <div className='greyHeaders'>
        <Header as='h2'>Explore more data</Header>
        <div>
          <a href={window.location.href + '/polarisation'} target='_blank'>
            <Button
              style={{ color: 'white', padding: 20, marginRight: 10 }}
              >POLARISATION DETAILS</Button>
          </a>
          <a href={window.location.href + '/resilience'} target='_blank'>
            <Button
              style={{ color: 'white', padding: 20 }}
              >RESILIENCE DETAILS</Button>
          </a>
        </div>
      </div>
      <Header as='h2' className='greyHeader'>Files</Header>
      <Grid>
        <Grid.Column mobile={16} tablet={4} computer={4}>
          <Icon name='file pdf outline' size='huge' color='red' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={9}>
          <p><b>Name: </b>{typeList[params.type]} Polarisation and resilience compared across the EU</p>
          <p><b>Format: </b> PDF</p>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={4} computer={3}>
          <Button
              style={{ marginBottom: 20, color: 'white', padding: '30px 0' }}
              size='big'
              onClick={() => getChart(
                {
                  title: typeList[params.type] + ' Polarisation and resilience compared across the EU',
                  charts: [{
                    title: typeList[params.type] + ' Polarisation score vs. Resilience score per Country'
                  }]
                },
                params.type,
                null,
                nameToId[params.id]
              )}
              download
              fluid>
            DOWNLOAD
          </Button>
        </Grid.Column>
      </Grid>
    </Layout>
    )
}

export default toolkitCountry



// WEBPACK FOOTER //
// ./src/components/ToolkitComponent/components/ToolkitCountry.js